import React from 'react';
import { Check, BookOpen, ShoppingCart, Moon, UtensilsCrossed } from 'lucide-react';
export function WhatIncludedSection() {
  const chapters = ["La 'barriga' 45+ no es un misterio: es un sistema", 'El objetivo real: desinflamar primero', 'El Triángulo 21D: cómo funciona y cómo medirlo', 'Proteína Primero: la regla más fácil que cambia todo', 'Carbos inteligentes y fibra: qué quitar, qué dejar', 'Fuerza mínima efectiva en casa (15–20 min)', "Caminata y 'zona tranquila': movimiento que baja antojos", 'Rutina Anti-Antojos: protocolos tarde-noche', 'Plan de comidas 21 días: menús rotativos', "Los '7 sabotajes' (y qué hacer el mismo día)", 'Semana 1–2–3: qué esperar y ajustes rápidos', "Mantenimiento y 'tu versión 2.0'"];
  const bonuses = [{
    icon: <Check className="w-5 h-5" data-id="element-179" />,
    title: 'Checklist diaria 21D',
    desc: 'Imprimible para tu refrigerador'
  }, {
    icon: <ShoppingCart className="w-5 h-5" data-id="element-180" />,
    title: 'Lista de compras',
    desc: 'Organizada por supermercado'
  }, {
    icon: <Moon className="w-5 h-5" data-id="element-181" />,
    title: "Guía 'Antojos 9pm'",
    desc: '12 respuestas rápidas'
  }, {
    icon: <UtensilsCrossed className="w-5 h-5" data-id="element-182" />,
    title: 'Mini-guía restaurantes',
    desc: 'Cómo pedir sin sabotearte'
  }];
  return <section className="py-20 bg-white" data-id="element-183">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-184">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-185">
          {/* Main Content - Chapters */}
          <div className="flex-1" data-id="element-186">
            <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#3D4852] mb-8" data-id="element-187">
              Qué incluye el Protocolo
            </h2>
            <div className="bg-[#F5F0E8]/30 p-8 rounded-3xl border border-[#F5F0E8]" data-id="element-188">
              <ul className="space-y-4" data-id="element-189">
                {chapters.map((chapter, index) => <li key={index} className="flex items-start gap-3" data-id="element-190">
                    <div className="mt-1 w-5 h-5 rounded-full bg-[#8B9A7D] flex items-center justify-center flex-shrink-0" data-id="element-191">
                      <Check className="w-3 h-3 text-white" data-id="element-192" />
                    </div>
                    <span className="text-gray-700 font-medium" data-id="element-193">{chapter}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Bonuses */}
          <div className="lg:w-1/3" data-id="element-194">
            <h3 className="text-2xl font-serif font-bold text-[#C17F6B] mb-8" data-id="element-195">
              Bonos de Regalo
            </h3>
            <div className="space-y-6" data-id="element-196">
              {bonuses.map((bonus, index) => <div key={index} className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-197">
                  <div className="w-10 h-10 rounded-full bg-[#C17F6B]/10 flex items-center justify-center text-[#C17F6B]" data-id="element-198">
                    {bonus.icon}
                  </div>
                  <div data-id="element-199">
                    <h4 className="font-bold text-[#3D4852]" data-id="element-200">{bonus.title}</h4>
                    <p className="text-sm text-gray-500" data-id="element-201">{bonus.desc}</p>
                  </div>
                </div>)}
            </div>

            <div className="mt-10 p-6 bg-[#3D4852] rounded-xl text-white text-center" data-id="element-202">
              <BookOpen className="w-8 h-8 mx-auto mb-3 text-[#8B9A7D]" data-id="element-203" />
              <p className="font-medium" data-id="element-204">Formato 100% Digital (PDF)</p>
              <p className="text-sm text-gray-400 mt-1" data-id="element-205">
                Descarga inmediata a tu email
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}